module.exports = __webpack_public_path__ + "static/vale-logo-a1e9291c218a58d0d2924628cbb84ee9.png";